// #region Imports

import * as $ from 'jquery';

// #endregion Imports

// #region Exports

export function initialize(): void {
    bindInputs();
}

// #endregion Exports

// #region Private constants
const inputSelector = '.js-submit-change';
// #endregion Private constants

// #region Private functions

function bindInputs(): void {
    $(inputSelector).on('change', handleChange);
}

function handleChange(): void {
    $(this).closest('form').submit();
}

// #endregion Private functions